export default {
    message: 'The {_field_} value must be valid.',
    validate: (value, args) => {
        let regex = new RegExp(args.regex.source);
        return regex.test(value);
    }
}
